import styles from './Certifications.module.css';

import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';

import { useState, useEffect } from 'react';
import { getCertifications } from "../../api.js";
import { useAuth } from '../../AuthContext';

import { CertificationItem } from '../CertificationItem/CertificationItem';
import { CertificationForm } from '../CertificationForm/CertificationForm';

export const Certifications = () => {
    const [ error, setError ] = useState(null);
    const [ loading, setLoading ] = useState(true);
    const [ certifications, setCertifications ] = useState([]);
    const [ openForm, setOpenForm ] = useState(false);
    const [ editingCert, setEditingCert ] = useState(null);

    const { token } = useAuth();

    const fetchData = async () => {
        try {
            setLoading(true);

            const certificationsData = await getCertifications(token);

            if (!certificationsData || certificationsData.error) {
                setError(certificationsData?.error || 'Failed to fetch certifications. Please try again.');

                return;
            }

            setCertifications(certificationsData);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleAdd = () => {
        setEditingCert(null);
        setOpenForm(true);
    };

    const handleEdit = (certification) => {
        setEditingCert(certification);
        setOpenForm(true);
    };

    const handleDelete = async () => {
        // The actual deletion is handled in CertificationItem component
        await fetchData(); // Refresh the list
    };

    const handleSave = () => {
        fetchData(); // Refresh the list
    };

    if (loading) {
        return <CircularProgress />;
    }

    if (error) {
        return <Alert variant="filled" severity="error">{ error }</Alert>;
    }

    return (
        <div className={ styles.certificationsContainer }>
            <div className={ styles.header }>
                <span>Certifications</span>

                <Button
                    variant="contained"
                    startIcon={ <AddIcon /> }
                    onClick={ handleAdd }
                    size="small"
                >
                    Add Certification
                </Button>
            </div>

            <div className={ styles.content }>
                { certifications.length === 0 ? (
                    <Alert severity="info">No certifications found. Click &quot;Add Certification&quot; to create one.</Alert>
                ) : (
                    certifications.map(certification => (
                        <CertificationItem
                            key={ certification.id }
                            certification={ certification }
                            onEdit={ handleEdit }
                            onDelete={ handleDelete }
                        />
                    ))
                ) }
            </div>

            <CertificationForm
                open={ openForm }
                onClose={ () => setOpenForm(false) }
                certification={ editingCert }
                onSave={ handleSave }
            />
        </div>
    );
};